/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `Navbar`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  AppsMenu: {
    Deliveries: `التسليم`,
    Orders: `أوامر`,
    Tooltip: `التطبيقات`,
  },
  ListItem: {
    Language: `لغة`,
    Login: `تسجيل الدخول`,
    Logout: `الخروج`,
    Orders: `طلباتي`,
    Policy: `سياسة الخصوصية`,
    Settings: `إعدادات`,
    Terms: `البنود و الظروف`,
  },
  SuperUser: `مستخدم سوبر`,
  UserMenuLanguage: {
    Heading: `اختر لغتك`,
  },
  UserMenuTheme: {
    DarkThemeOff: `موضوع الظلام: قبالة`,
    DarkThemeOn: `موضوع مظلم: في`,
    Description: `يحول اللون الداكن الأسطح الضوئية للصفحة مظلمة ، مما يجعل تجربة مثالية ليلاً. حاول!`,
    Disclaimer: `سيتم تطبيق إعداد "المظهر المظلم" على هذا المتصفح فقط.`,
    Heading: `موضوع مظلم`,
  },
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  AppsMenu: {
    Deliveries: `Deliveries`,
    Orders: `Orders`,
    Tooltip: `Apps`,
  },
  ListItem: {
    Language: `Language`,
    Login: `Login`,
    Logout: `Logout`,
    Orders: `Orders`,
    Policy: `Privacy Policy`,
    Settings: `Settings`,
    Terms: `Terms & Conditions`,
  },
  SuperUser: `Superuser`,
  UserMenuLanguage: {
    Heading: `Choose your language`,
  },
  UserMenuTheme: {
    DarkThemeOff: `Dark theme: Off`,
    DarkThemeOn: `Dark theme: On`,
    Description: `Dark theme turns the light surfaces of the page dark, creating an experience ideal for night. Try it out!`,
    Disclaimer: `Your Dark theme setting will apply to this browser only.`,
    Heading: `Dark theme`,
  },
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  AppsMenu: {
    Deliveries: `交付`,
    Orders: `命令`,
    Tooltip: `应用`,
  },
  ListItem: {
    Language: `语言`,
    Login: `登录`,
    Logout: `登出`,
    Orders: `我的订单`,
    Policy: `隱私政策`,
    Settings: `设置`,
    Terms: `條款和條件`,
  },
  SuperUser: `超级用户`,
  UserMenuLanguage: {
    Heading: `选择你的语言`,
  },
  UserMenuTheme: {
    DarkThemeOff: `黑暗主题：关闭`,
    DarkThemeOn: `黑暗主题：开启`,
    Description: `黑暗主题将页面的光线表面变暗，营造出适合夜晚的体验。 试试看！`,
    Disclaimer: `您的黑暗主题设置仅适用于此浏览器。`,
    Heading: `黑暗的主题`,
  },
});
